import { IngestionStep } from "@tfg/db/browser"
import { useCallback, useMemo } from "react"
import { useTranslation } from "react-i18next"

import { FindIngestionsResponseDto } from "~/gen/api"

type Props = {
  handleImportModalOpen: (
    ingestion: FindIngestionsResponseDto,
    isBlankIngestion: boolean
  ) => void
}

type RetryAction = {
  trigger: (row: FindIngestionsResponseDto) => void
  name: string
}

type GetRetryAction = (row: FindIngestionsResponseDto) => RetryAction | null

export const useRetryAction = ({
  handleImportModalOpen,
}: Props): GetRetryAction => {
  const { t } = useTranslation("admin")

  const resolver: Record<IngestionStep, RetryAction | null> = useMemo(
    () => ({
      [IngestionStep.INGEST_BLANK_PRODUCTS]: {
        trigger: (row: FindIngestionsResponseDto) => {
          handleImportModalOpen(row, true)
        },
        name: t("ingestion.retry.blank"),
      },
      [IngestionStep.INGEST_PRODUCTS]: {
        trigger: (row: FindIngestionsResponseDto) => {
          handleImportModalOpen(row, false)
        },
        name: t("ingestion.retry.products"),
      },
      [IngestionStep.VERIFY_BLANK_PRODUCTS]: null,
      [IngestionStep.VERIFY_PRODUCTS]: null,
      [IngestionStep.LAUNCH_TRACEABILITY]: null,
    }),
    [handleImportModalOpen, t]
  )

  const getRetryAction = useCallback(
    (row: FindIngestionsResponseDto) => {
      const { step } = row

      if (!step) {
        return null
      }

      return resolver[step]
    },
    [resolver]
  )

  return getRetryAction
}
